import React, { Component } from "react";
import Details from "./Details.css";
import { getPaginatedArray } from "../utils/helpers";

class DetailComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { page, data } = this.props;
    const showDetailCards = (cardData, page) => {
      if (cardData.length > 0) {
        const dataToDisplay = getPaginatedArray(8, cardData[0].data, page);
        return dataToDisplay.map((subCategory, index) => {
          return (
            <li key={index} className="list-feature-group text-center">
              <h4> {subCategory.title} </h4>
              <p>{subCategory.description} </p>
              <a href={subCategory.url} target="_blank">
                <button className="btn btn-sm">Learn More</button>
              </a>
            </li>
          );
        });
      } else {
        return <p>No Data</p>;
      }
    };

    return <div className="accordion featureDetails">{showDetailCards(data, page ? page : 1)}</div>;
  }
}

export default DetailComponent;



// WEBPACK FOOTER //
// ./src/components/features/Details.js